<template lang="pug">
InputGroup.markdown-input(:name="name", :label="label", :optional="optional")
  template(v-slot:secondary)
    a(
      href="https://approachguides.com/markdown-pointers/"
      target="_blank"
      class="text-xs text-supplement hover:text-primary-hover font-medium uppercase"
    )
      span(clas="flex items-center")
        Icon(icon="markdown", prefix="fab")
        span(class="ml-2") Formatting help

  TextInput(textarea, @input="updateValue", :value="value", v-bind="$attrs")
  Alert(v-show="lengthFeedback.status", :type="lengthFeedback.status", :content="lengthFeedback.content")
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    suggestedMinLength: {
      type: [Number, null],
      default: null
    },
    suggestedMaxLength: {
      type: [Number, null],
      default: null
    },
    optional: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    lengthFeedback() {
      const feedback = {
        status: null,
        content: null,
        length: this.value && this.value.length
      }

      const { length } = feedback
      const characterWord = length === 1 ? "character" : "characters"

      if (this.suggestedMinLength && this.suggestedMaxLength) {
        if (!length || length <= this.suggestedMinLength) {
          feedback.status = "info"
          feedback.content = `We recommend ${this.suggestedMinLength}-${this.suggestedMaxLength} characters.`
        } else if (length >= this.suggestedMaxLength) {
          feedback.status = "warning"
          feedback.content = `**${length}** ${characterWord}. We recommend fewer than ${this.suggestedMaxLength}.`
        } else {
          feedback.status = "success"
          feedback.content = `${length} ${characterWord}`
        }
      } else if (this.suggestedMinLength) {
        if (!length || length <= this.suggestedMinLength) {
          feedback.status = "info"
          feedback.content = `We recommend more than ${this.suggestedMinLength} characters.`
        } else {
          feedback.status = "success"
          feedback.content = `${length} ${characterWord}`
        }
      } else if (this.suggestedMaxLength) {
        if (!length) {
          feedback.status = "info"
          feedback.content = `We recommend fewer than ${this.suggestedMaxLength} characters.`
        } else if (length >= this.suggestedMaxLength) {
          feedback.status = "warning"
          feedback.content = `**${length}** ${characterWord}. We recommend fewer than ${this.suggestedMaxLength}.`
        } else {
          feedback.status = "success"
          feedback.content = `${length} ${characterWord}`
        }
      }

      return feedback
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit("input", value)
    }
  }
}
</script>

<style>
.markdown-input {
  .alert {
    @apply mt-4 border-none p-0;

    &-icon {
      @apply mr-3 h-6 w-8 rounded-full text-xs;
      min-width: auto;
    }
  }

  .formatting-help {
    .dropdown-trigger-label {
      @apply text-xs font-semibold uppercase text-gray-500;
    }

    .dropdown-menu {
      @apply max-w-full py-0;
      min-width: 250px;

      @screen md {
        min-width: 400px;
      }
    }
  }
}
</style>
